import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Alert } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import _ from "lodash";

import { doPostUserOffer, doBidValidation } from "../../actions/offerAction";
import {
  doPostShippingCost,
  doFetchCountries,
  doFetchProvinces,
  doFetchCities,
  getHistoryShipping
} from "../../actions/postalCodeAction";
import { doFetchProfile } from "../../actions/authAction";

import SneakerInfoContainer from "../PageCheckout/Detail/SneakerInfoContainer";
import ShippingPayment from "./ShippingPayment";
import InputOffer from "./InputOffer";
import NoteOffer from "./NoteOffer";
import { Button } from "../Forms";
import {
  ModalAddressBook,
  ModalOutOfStock,
  ModalPaymentMethod
} from "../Modals";
import UserBalanceInfoModal from "../PageCheckout/UserBalanceInfoModal";
import BottomSection from "../PageCheckout/BottomSection";
import {
  BANKTRANSFER,
  CREDITCARD,
  FULLWALLET,
  getAdmFees,
  BCA_VA,
  BRI_VA,
  MANDIRI_VA
} from "../../constants/paymentMethods";
import { validateUmbre } from "../../config/umbre";
import { OFFER_DEPOSIT } from "../../config";
import classNames from "classnames";
import { timingSafeEqual } from "crypto";
import { isNumeric } from "../../helpers/regex";
import { convertToRupiah, parsePhone, parsePhoneCode } from "../../utils";
import Loading from "../../components/Loading";
import ModalTermsOffer from "../Modals/ModalTermsOffer";
import styled from "styled-components";
import Analytics from "../../services/Analytics";
const OUT_OF_STOCK_MSG = "Sorry, someone else bought this product!";
const ERROR_SAME_OFFER =
  "You have already make an offer for this sneaker with same size!";

class DetailOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _openModalAddress: false,
      _openModalError: false,
      _openModalPayment: false,
      _errorAddress: "",
      _paymentType: props.currency === "IDR" ? BCA_VA : CREDITCARD,
      _id_shipping: "",
      _alias: "",
      _fullName: "",
      _phoneNumber: "",
      _alamat: "",
      _phone: "",
      _phoneSelected: null,
      _phoneCodeSelected: null,
      _phoneList: [{ value: "", label: "Code*", code3: "" }],
      _countrySelected: null,
      _countryCodeSelected: null,
      _countryList: [
        { value: "", label: "Country*", code3: "", phone_code: null }
      ],
      _province: "",
      _provinceSelected: null,
      _provinceList: [{ value: "", label: "Province*" }],
      _city: "",
      _citySelected: null,
      _cityList: [{ value: "", label: "City*" }],
      _district: "",
      _subDistrict: "",
      _postalCode: "",
      _note: "",
      _stillfetchCity: false,
      _shippingFee: 0,
      _discount: 0,
      _administrationFee: 0,
      _productPromo: 0,
      _error: null,
      _messageField: null,
      walletPayment: false,
      _umbreEnabled: false,
      umbreShipping: false,
      addingShipping: false,
      errorSameSize: false,
      _isSubmit: false,
      _termsOffer: false,
      _isErrorShippingFetch: false,
      _bidValidation: false,
      _balance: 0,
      sellerCredit: 0,
      kickPoints: 0,
      sellerCreditUsage: 0,
      kickPointsUsage: 0,
      balanceUsage: 0, //kick credit
      isCreditUse: false,
      isUseKickPoints: false,
      isOpenModalInfo: false
    };

    this.toggleModalAddress = this.toggleModalAddress.bind(this);
    this._submitOffer = this._submitOffer.bind(this);
    this._handleCreateAddress = this._handleCreateAddress.bind(this);
    this.toggleModalPayment = this.toggleModalPayment.bind(this);
    this._handlePaymentTypeChange = this._handlePaymentTypeChange.bind(this);
    this._getAdmFee = this._getAdmFee.bind(this);
    this._getTotal = this._getTotal.bind(this);
    this._handleUmbreShippingCheckedChange = this._handleUmbreShippingCheckedChange.bind(
      this
    );
    this._toggleUmbreEnabled = this._toggleUmbreEnabled.bind(this);
    this._handleSelectPhoneChange = this._handleSelectPhoneChange.bind(this);
    this._buildCountryOptions = this._buildCountryOptions.bind(this);
    this._handleSelectCountryChange = this._handleSelectCountryChange.bind(
      this
    );
    this._buildProvinceOptions = this._buildProvinceOptions.bind(this);
    this._handleSelectProvinceChange = this._handleSelectProvinceChange.bind(
      this
    );
    this._buildCityOptions = this._buildCityOptions.bind(this);
    this._handleSelectCityChange = this._handleSelectCityChange.bind(this);
    this.onChooseShipping = this.onChooseShipping.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this.toggleModalTermsOffer = this.toggleModalTermsOffer.bind(this);
  }

  componentDidMount() {
    // this._buildProvinceOptions();
    if (!this.props.product.id) {
      //force redirect to product detail page, if product props still missing.
      this.props.history.replace(this.props.match.url);
      return;
    }
    this.props.getCountries();
    this.props.getHistoryShipping();
    this.props.bidValidation();
    this.props.doFetchProfile();
  }

  async componentDidUpdate(prevProps) {
    const { bidValidation } = this.props.dataOffer;
    const { shippingHistory, provinces, countries } = this.props.dataPostalCode;
    const { userdata } = this.props.dataAuth;
    const prevShippingHistory = prevProps.dataPostalCode.shippingHistory;

    //fetch user balances
    if (prevProps.dataAuth.userdata.isFetch !== userdata.isFetch) {
      if (userdata.isFetch && !this.state._isFetch) {
        this.setState({
          _isFetch: userdata.isFetch
        });
      } else if (!userdata.isFetch && this.state._isFetch) {
        this.setState({
          _isFetch: !this.state._isFetch,
          _balance: parseFloat(userdata.balance),
          sellerCredit: parseFloat(userdata.balance_with_fee),
          kickPoints: parseFloat(userdata.locked_balance)
        });
      }
    }

    if (
      bidValidation.status_code !== 200 &&
      !bidValidation.isFetch &&
      bidValidation.error &&
      prevProps.dataOffer.bidValidation.isFetch !== bidValidation.isFetch
    ) {
      this.setState({ _termsOffer: true, _bidValidation: true });
    }

    if (prevProps.currency !== this.props.currency) {
      this.setState({
        _paymentType: this.props.currency === "IDR" ? BCA_VA : CREDITCARD
      });
    }

    if (
      shippingHistory.status_code === 200 &&
      !shippingHistory.isFetch &&
      prevShippingHistory.isFetch != shippingHistory.isFetch
    ) {
      if (shippingHistory.data.length > 0) {
        const latestShipping = shippingHistory.data[0];
        const codeArea = parsePhoneCode(latestShipping.phone_number);

        this.setState(
          {
            _alias: latestShipping ? latestShipping.alias : "",
            _fullName: latestShipping ? latestShipping.full_name : "",
            _phone: latestShipping ? codeArea : "",
            _phoneNumber: latestShipping
              ? parsePhone(latestShipping.phone_number, true, codeArea)
              : "",
            _alamat: latestShipping ? latestShipping.street_address : "",
            _notes: latestShipping ? latestShipping.note : "",
            _countryCodeSelected: latestShipping ? latestShipping.country : "",
            _province: latestShipping ? latestShipping.province : "",
            _postalCode: latestShipping ? latestShipping.postal_code : "",
            _stillfetchCity: true,
            _city: latestShipping ? latestShipping.city : "",
            _id_shipping: latestShipping ? latestShipping.id : ""
          },
          () => {
            this._buildCountryOptions();
            // this._calculateShippingFee(this._getProvinceId())
          }
        );
      }
    }

    //After fetch countries done.
    if (
      prevProps.dataCountries.isFetch &&
      prevProps.dataCountries.isFetch !== this.props.dataCountries.isFetch
    ) {
      const { error } = this.props.dataCountries;
      if (!error) {
        this._buildCountryOptions();
      }
    }

    //After fetch provinces done.
    if (
      prevProps.dataProvinces.isFetch &&
      prevProps.dataProvinces.isFetch !== this.props.dataProvinces.isFetch
    ) {
      const { error } = this.props.dataProvinces;

      if (!error) {
        this._buildProvinceOptions(this.state._countryCodeSelected);
        this._toggleUmbreEnabled(this._getProvinceId(), this.state._city);
      }
    }

    if (
      prevProps.dataCities.isFetch &&
      prevProps.dataCities.isFetch !== this.props.dataCities.isFetch
    ) {
      const { dataCities } = this.props;

      if (!dataCities.error) {
        this._buildCityOptions();
      }
    }

    if (
      prevProps.dataCouriers.isFetch &&
      prevProps.dataCouriers.isFetch !== this.props.dataCouriers.isFetch
    ) {
      const { cost, error } = this.props.dataCouriers;
      this.setState({
        _shippingFee: cost || 0,
        _isErrorShippingFetch: error !== null
      }, () => this._handleBalanceUsage());
    }

    if (
      prevProps.dataOffer.submitOffer.isSubmit &&
      prevProps.dataOffer.submitOffer.isSubmit !==
        this.props.dataOffer.submitOffer.isSubmit
    ) {
      const { error, data } = this.props.dataOffer.submitOffer;
      const { state } = this.props.history.location;
      this.props.clearBidAmount();

      if (this.props.dataOffer.submitOffer.isSubmit == true) {
        this.setState({
          _isSubmit: true
        });
      }
      if (error) {
        const { errors } = this.props.dataOffer.submitOffer.error;
        if (error.status_code == 422) {
          const uiKeys = {
            amount: "bidAmount"
          };
          let _errors = {};
          Object.keys(errors).map(key => {
            let msg = errors[key][0];
            if (typeof errors[key][0] === "object")
              msg = errors[key][0].message;
            const getUiKey = Object.keys(uiKeys).find(uiKey => uiKey === key);
            if (getUiKey) _errors[uiKeys[getUiKey]] = [msg];
            else _errors[key] = [msg];
          });
          this.setState({
            _error: { ...error, errors: { ..._errors } },
            _errorAddress: "Please input a shipping address!"
          });
          if (errors) {
            if (errors.user_sell_id) {
              this.setState({
                _openModalError: true
              });
            }
          }
        }
        if (error.status_code === 400) {
          if (
            error.message == "Your balance is not enough to enter bid systems!"
          )
            this.setState({
              _termsOffer: true,
              _bidValidation: true
            });
          else
            this.setState({
              errorSameSize: true,
              _openModalError: true
            });
        } else {
          this.setState({
            _error: {
              ...error
            }
          });
        }
      } else {
        Analytics.recordOffer(
          data.product_variant.display_name,
          data.product_variant.product.category.name,
          data.product_variant.SKU,
          "product",
          data.amount,
          "IDR",
          data.user_id,
          data.user.username,
          state.id,
          data.product_variant_id
        );
        this.props.history.push({
          pathname: `${this.props.match.url}/offer/live`,
          search: this.props.history.location.search,
          state: this.props.history.location.state
        });
      }
    }

    if (prevProps.bidAmount !== this.props.bidAmount) {
      await this._validateBidAmountInput();
      const { _paymentType, _balance, sellerCredit, kickPoints } = this.state;
      const totalBalance = _balance + sellerCredit + kickPoints;
      if (_paymentType !== BANKTRANSFER) {
        this.setState({
          walletPayment: false,
          _administrationFee: 0
        });
      }
      if(this._getTotal() > totalBalance) {
        this.setState({ 
          isCreditUse: false, 
          _paymentType: BCA_VA,
          isUseKickPoints: false,
          kickPointsUsage: 0,
          sellerCreditUsage: 0,
          balanceUsage: 0
         })
      }
    }
  }

  _bidAmountRules() {
    const messages = {
      error: [],
      success: []
    };
    const {
      asking_price,
      highest_bid
    } = this.props.history.location.state.selectedSize;
    let { sell: { subsidy_price } } = this.props;
    const limitOffer = parseInt(asking_price) - 50000;
    const { amount } = highest_bid == null ? 0 : highest_bid;
    const { bidAmount, ratio, currency } = this.props;
    const buyNow = <ButtonBuy onClick={this.props.onBuy}>buy now!</ButtonBuy>;
    subsidy_price = subsidy_price? subsidy_price : 0
    
    //bid amount
    if (bidAmount === "") {
      messages.error.push("Please fill in the amount of your Offer.");
    } else if (!isNumeric(bidAmount)) {
      messages.error.push("This field must be numeric.");
    } else if (bidAmount / ratio == (parseFloat(asking_price) - parseInt(subsidy_price))) {
      messages.error.push(
        <span className="text-left text-danger">
          Cannot make an offer with the same price {currency}{" "}
          {convertToRupiah(parseFloat(asking_price * ratio) - parseInt(subsidy_price))}. You should {buyNow}
        </span>
      );
    } else if (bidAmount / ratio > (parseFloat(asking_price) - parseInt(subsidy_price))) {
      messages.error.push(
        <span className="text-left text-danger">
          Cannot make an offer greater than {currency}{" "}
          {convertToRupiah(parseFloat((asking_price - parseInt(subsidy_price)) * ratio))}. You should {buyNow}
        </span>
      );
    }

    if (messages.error.length === 0) {
      if (bidAmount / ratio > parseFloat(amount)) {
        messages.success.push(`You have the highest offer.`);
      }
    }
    return messages;
  }

  async _validateBidAmountInput() {
    const { error, success } = this._bidAmountRules();
    const errors = error.reduce((err, item) => {
      err["bidAmount"] = err["bidAmount"]
        ? [...err["bidAmount"], item]
        : [item];
      return { ...err };
    }, {});
    const _messageField = success.length
      ? {
          bidAmount: [success[0]]
        }
      : null;
    const errorData = Object.keys(errors).length
      ? {
          errors: { ...errors },
          status_code: 422,
          message: "Please check your form and try again."
        }
      : null;
    await this.setState({
      _error: errorData,
      _messageField
    });
    const { _error } = this.state;
    return _error === null;
  }

  _getProvinceId() {
    const { _province, _provinceSelected } = this.state;

    if (this.state._provinceSelected) return this.state._provinceSelected.id;

    return 0;
  }

  _handleSelectPhoneChange(selected) {
    if (selected) {
      this.setState({
        _phone: selected.label,
        _phoneCodeSelected: selected.label,
        _phoneSelected: selected
      });
    } else {
      this.setState({
        _phone: "",
        _phoneCodeSelected: "",
        _phoneSelected: selected
      });
    }
  }

  _handleSelectCountryChange(selected) {
    if (selected) {
      this.setState(
        {
          _countryCodeSelected: selected.code3,
          _countrySelected: selected,
          _province: "",
          _provinceList: [
            { value: "", label: "Province*" },
            { value: "", label: "Loading province.." }
          ],
          _city: "",
          _cityList: [
            { value: "", label: "City*" },
            { value: "", label: "Loading city.." }
          ]
        },
        () => {
          this._buildProvinceOptions(selected.code3);
          // this.props.getProvinces(selected.code3)
        }
      );
    } else {
      this.setState({
        _countryCodeSelected: null,
        _countrySelected: null,
        _province: "",
        _provinceList: [
          { value: "", label: "Province*" },
          { value: "", label: "Loading province.." }
        ],
        _city: "",
        _cityList: [
          { value: "", label: "City*" },
          { value: "", label: "Loading city.." }
        ]
      });
    }
  }

  _handleSelectProvinceChange(selected) {
    const { _countryCodeSelected, _provinceSelected } = this.state;

    if (selected) {
      this._toggleUmbreEnabled(this._getProvinceId(), null);

      this.setState(
        {
          _province: selected.label,
          _provinceSelected: selected,
          _city: "",
          _cityList: [
            { value: "", label: "City*" },
            { value: "", label: "Loading city.." }
          ]
        },
        () => {
          this._calculateShippingFee(this._getProvinceId());
          this.props.getCities(
            _countryCodeSelected,
            selected && selected.label
          );
        }
      );
    } else {
      this.setState({
        _province: "",
        _provinceSelected: null,
        _city: "",
        _cityList: [
          { value: "", label: "City*" },
          { value: "", label: "Loading city.." }
        ]
      });
    }
  }

  _handleSelectCityChange(selected) {
    if (selected) {
      this.setState({ _citySelected: selected });
      this._toggleUmbreEnabled(this._getProvinceId(), selected && selected.id);
    } else {
      this.setState({
        _citySelected: null
      });
    }
  }

  _buildCountryOptions() {
    if (this.props.dataCountries.status_code !== 200) this.props.getCountries();
    else {
      const { data } = this.props.dataCountries;
      const {
        _countrySelected,
        _phoneSelected,
        _countryCodeSelected
      } = this.state;
      const countries = data.map((country, index) => ({
        value: index,
        label: country.name,
        code3: country.code3,
        phone_code: country.phone_code
      }));

      const getCountry = countries.find(
        item => item.code3 == this.state._countryCodeSelected
      );

      if (getCountry) {
        this.setState(
          {
            _countrySelected: getCountry
          },
          () => {
            this._buildProvinceOptions(getCountry && getCountry.code3);
            // this.props.getProvinces(getCountry && getCountry.code3)
          }
        );
      }

      const phones = data.map((phone, index) => ({
        value: index,
        label: phone.phone_code,
        code3: phone.code3
      }));

      const getPhone = phones.find(
        item =>
          item.label ==
          (_phoneSelected ? _phoneSelected.label : this.state._phone)
      );

      if (getPhone) {
        this.setState({
          _phoneSelected: getPhone
        });
      }

      this.setState({
        _countryList: [
          { value: "", label: "Country*", code3: "", phone_code: null },
          ...countries
        ],
        _phoneList: [{ value: "", label: "Code*", code3: "" }, ...phones]
      });
    }
  }

  _buildProvinceOptions(countryId = "IDN") {
    const { data, isFetch } = this.props.dataProvinces;
    const { data: dCountries } = this.props.dataCountries;
    let country = dCountries.find(item => item.code3 === countryId);
    country = country ? country.id : 1;
    let refetch = false;
    if (this.props.dataProvinces.status_code !== 200) {
      refetch = true;
    } else if (data && data.length) {
      refetch = country !== data[0].country_id;
      // console.log("id: ", country, "data[0].country_id: ", data[0].country_id, "refetch: ", refetch)
    }
    if (refetch) this.props.getProvinces(countryId);
    else {
      const { data } = this.props.dataProvinces;
      const { _provinceSelected, _countrySelected } = this.state;
      const provinces = data.map((province, index) => ({
        value: index,
        label: province.name,
        id: province.id
      }));

      let provinceSelected = _provinceSelected;
      let fetchCity = false;
      if (_provinceSelected == null || _provinceSelected !== null) {
        const getProvince = provinces.find(
          item => item.label == this.state._province
        );
        fetchCity = !fetchCity;
        provinceSelected = getProvince ? getProvince : null;
        // this.setState({
        //   _provinceSelected: getProvince? getProvince: null
        // }, () => {
        //   this.props.getCities(_countrySelected && _countrySelected.code3, getProvince && getProvince.label)
        // })
      }

      this.setState(
        {
          _provinceList: [{ value: "", label: "Province*" }, ...provinces],
          _provinceSelected: provinceSelected
        },
        () => {
          if (fetchCity) {
            this.props.getCities(
              _countrySelected && _countrySelected.code3,
              provinceSelected && provinceSelected.label
            );
          }
          this._calculateShippingFee(this._getProvinceId());
        }
      );
    }
  }

  _buildCityOptions() {
    const { data } = this.props.dataCities;
    const {
      _countrySelected,
      _provinceSelected,
      _city,
      _cityList,
      _citySelected
    } = this.state;

    if (data.length > 0) {
      const allCity = data.map((item, index) => ({
        value: index,
        label: item.name,
        id: item.id
      }));

      //checking for duplicates item
      const newCityList = _.uniqBy(allCity, "label");

      //find selected city
      const getSelectedCity = newCityList.find(item => item.label === _city);

      this.setState({
        _citySelected: getSelectedCity,
        _cityList: [{ value: "", label: "City*" }, ...newCityList]
      });

      if (getSelectedCity) {
        this._toggleUmbreEnabled(
          this._getProvinceId(),
          _citySelected && _citySelected.id
        );
      }
    }
  }

  toggleModalAddress() {
    this.setState({
      _openModalAddress: !this.state._openModalAddress
    });
  }

  toggleModalPayment() {
    this.setState({
      _openModalPayment: !this.state._openModalPayment
    });
  }

  toggleModalTermsOffer() {
    this.setState({
      _termsOffer: !this.state._termsOffer
    });
  }

  onToggleBalanceInfo = () => {
    this.setState({ isOpenModalInfo: !this.state.isOpenModalInfo })
  }

  _handleChange(e) {
    const lastState = { ...this.state };
    lastState[e.target.name] = e.target.value;
    this.setState({ ...lastState });
  }

  _handlePaymentTypeChange(e) {
    const lastState = { ...this.state };
    const { ratio } = this.props;
    const { _balance, sellerCredit } = this.state;
    const totalBalance = _balance + sellerCredit;
    lastState[e.target.name] = e.target.value;

    lastState._administrationFee = getAdmFees(
      e.target.value,
      parseFloat(this.props.bidAmount / ratio),
      this.state._shippingFee,
      this.state._discount
    );
    
    this.setState({ ...lastState });

    if (this.state._paymentType !== FULLWALLET && (totalBalance < OFFER_DEPOSIT)) {
      this.setState({ _termsOffer: true })
    }
  }

  _getAdmFee() {
    const { ratio } = this.props;
    return getAdmFees(
      this.state._paymentType,
      parseFloat(this.props.bidAmount / ratio),
      parseFloat(this.state._shippingFee),
      this.state._discount
    );
  }

  _getTotal() {
    const { ratio } = this.props;
    return parseFloat(
      parseFloat(this.props.bidAmount / ratio) +
        parseFloat(this.state._shippingFee) -
        this.state._discount +
        this._getAdmFee() +
        parseFloat(this.state._productPromo)
    );
  }

  _hasError = name => {
    if (this.state._error !== null && this.state._error.status_code === 422) {
      return (
        Object.keys(this.state._error.errors).filter(err => err === name)
          .length > 0
      );
    }
    return false;
  };

  _validateForm() {
    const { _error } = this.state;
    let errors = {};

    if (
      this.state._alias === "" ||
      this.state._alias === undefined ||
      this.state._alias === null
    )
      errors["_alias"] = ["Please insert alias."];
    if (
      this.state._fullName === "" ||
      this.state._fullName === undefined ||
      this.state._fullName === null
    )
      errors["_fullName"] = ["Please insert recipient name."];
    if (
      this.state._phone === "" ||
      this.state._phone === undefined ||
      this.state._phone === null ||
      this.state._phoneSelected === null
    )
      errors["_phone"] = ["Please insert area code ."];
    if (
      this.state._phoneNumber === "" ||
      this.state._phoneNumber === undefined ||
      this.state._phoneNumber === null
    )
      errors["_phoneNumber"] = ["Please insert phone number."];
    else if (!isNumeric(this.state._phoneNumber))
      errors["_phoneNumber"] = ["Phone number must be numeric"];
    if (
      this.state._alamat === "" ||
      this.state._alamat === undefined ||
      this.state._alamat === null
    )
      errors["_alamat"] = ["Please insert address."];
    if (
      this.state._countrySelected === "" ||
      this.state._countrySelected === undefined ||
      this.state._countrySelected === null
    )
      errors["_country"] = ["Please choose country."];
    if (
      this.state._province === "" ||
      this.state._province === undefined ||
      this.state._province === null ||
      this.state._province == -1
    )
      errors["_province"] = ["Please choose province."];
    if (
      this.state._citySelected === "" ||
      this.state._citySelected === undefined ||
      this.state._citySelected === null
    )
      errors["_city"] = ["Please choose city."];
    if (
      this.state._postalCode === "" ||
      this.state._postalCode === undefined ||
      this.state._postalCode === null ||
      this.state._postalCode == -1
    )
      errors["_postalCode"] = ["Please insert postal code."];
    else if (!isNumeric(this.state._postalCode))
      errors["_postalCode"] = ["Postal code must be numeric."];

    if (Object.keys(errors).length) {
      this.setState({
        _error: {
          errors: { ...errors },
          errorShipping: true,
          status_code: 422,
          message: "Harap isi semua column berbintang"
        }
      });
    }

    return errors;
  }

  async _submitOffer(e) {
    e.preventDefault();
    const { ratio, currency } = this.props;
    const { isUseKickPoints, isCreditUse } = this.state;
    const isValidBidAmount = await this._validateBidAmountInput(); //here
    const parentDiv = document.getElementById("pageCheckoutOffer");
    const buffer = 120;
    if (!isValidBidAmount) {
      if (parentDiv) {
        const parentOffsetTop = parentDiv.offsetTop;
        const offsetTop = this.inputOfferRef.containerRefs.offsetTop;
        window.scrollTo(0, offsetTop + parentOffsetTop - buffer);
      }
      return false;
    }
    const valid = this._validateForm();
    if (Object.keys(valid).length) {
      const {
        state: { _collapseShipping, _collapsePayment }
      } = this.shippingPaymentRefs;
      if (!_collapseShipping) this.shippingPaymentRefs.shippingToggle();
      if (!_collapsePayment) this.shippingPaymentRefs.paymentToggle();
      if (parentDiv) {
        const parentOffsetTop = parentDiv.offsetTop;
        const offsetTop = this.shippingPaymentRefs.containerRefs.offsetTop;
        window.scrollTo(0, offsetTop + parentOffsetTop - buffer);
      }
      return false;
    }
    const { state } = this.props.history.location;
    const { provinces } = this.props.dataPostalCode;

    const getCity = this.state._cityList.filter(
      city => city.value === this.state._city
    );

    const { data } = this.props.dataProvinces;

    // const code = this.state._phone;
    const code = this.state._phoneSelected && this.state._phoneSelected.label;
    const number = this.state._phoneNumber;

    const payload = {
      shipping_id: this.state._id_shipping,
      shipping: {
        id: this.state.addingShipping ? null : this.state._id_shipping,
        alias: this.state._alias,
        full_name: this.state._fullName,
        phone_number: `+${code.concat(number)}`,
        street_address: this.state._alamat,
        country:
          this.state._countrySelected && this.state._countrySelected.code3,
        province:
          this.state._provinceSelected && this.state._provinceSelected.label,
        city: this.state._citySelected && this.state._citySelected.label,
        district: this.state._district,
        sub_district: this.state._subDistrict,
        postal_code: this.state._postalCode,
        note: this.state._note
      },
      product_variant_id: state.selectedSize.product_variant_id,
      size_id: state.selectedSize.size.id,
      payment_method: isCreditUse || isUseKickPoints? FULLWALLET : this.state._paymentType,
      amount: this.props.bidAmount / ratio,
      // amount: this.props.history.location.state._bidAmount,
      ka_courier_price: this.state._shippingFee,
      administration_fee: this.state._administrationFee,
      // expiry: 7,
      user_sell_id: state.id,
      point_enabled: isUseKickPoints
    };
    this.props.doPostUserOffer(payload);
  }

  _handleCreateAddress() {
    this.props.history.push("/user_dashboard/profile-settings");
  }

  _handleWalletPaymentCheckedChange = (value, type = BCA_VA) => {
    const { _discount, _shippingFee, _balance, sellerCredit, kickPoints } = this.state;
    const { ratio } = this.props;
    const paymentType = value ? FULLWALLET : type;
    const isTotalGreaterThanSeller = this._getTotal() > sellerCredit;
    const userBalanceUsage = isTotalGreaterThanSeller? (_balance > (this._getTotal() - sellerCredit)? this._getTotal() - sellerCredit : _balance) : 0;

    this.setState({
      walletPayment: value,
      isCreditUse: value,
      // _paymentType: paymentType,
      _administrationFee: this._getAdmFee(
        paymentType,
        this.props.bidAmount / ratio,
        _shippingFee,
        _discount
      )
    }, () => this._handleBalanceUsage());
  };

  _handleKickPointCheckedChange = (value, paymentType = BCA_VA) => {
    const { sellerCreditUsage, balanceUsage, kickPoints } = this.state;
    const totalActiveBalance = sellerCreditUsage + balanceUsage;
    const remainingPayment = this._getTotal() - totalActiveBalance;

    this.setState({
      isUseKickPoints: value,
      _paymentType: paymentType
    }, () => {
      this._handleBalanceUsage();
    });
  }

  _handlePaymentType = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage } = this.state;
    const totalActiveBalance = sellerCreditUsage + balanceUsage + kickPointsUsage;
    const remainingPayment = this._getTotal() - totalActiveBalance;

    this.setState({ _paymentType: remainingPayment > 0? BCA_VA : FULLWALLET })
  }

  //handle credit calculation
  _handleCalculation = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    let remainingPayment, usageBalancePoint, usageBalanceSeller, usageBalance;

    if (isUseKickPoints && isCreditUse) {
      // Kick point split payment calculation
      const pointUsage = (kickPoints >= this._getTotal()) ? this._getTotal() : kickPoints;
      usageBalancePoint = isUseKickPoints ? pointUsage : 0;
      const priceAfterKickPointsUsage = this._getTotal() - usageBalancePoint;

      // Seller credit split payment calculation
      const sellerBalanceUsage = sellerCredit >= priceAfterKickPointsUsage ? priceAfterKickPointsUsage : sellerCredit;
      usageBalanceSeller = priceAfterKickPointsUsage > 0 ? sellerBalanceUsage : 0;
      const priceAfterSellerCreditUsage = priceAfterKickPointsUsage - usageBalanceSeller;

      // Kick credit split payment calculation
      const creditBalanceUsage = _balance >= priceAfterSellerCreditUsage ? priceAfterSellerCreditUsage : _balance;
      usageBalance = priceAfterSellerCreditUsage > 0 ? creditBalanceUsage : 0;
      remainingPayment = this._getTotal() - usageBalancePoint - usageBalanceSeller - usageBalance;
    } else if (isUseKickPoints && !isCreditUse) {
      // Kick point split payment calculation
      const pointUsage = (kickPoints >= this._getTotal()) ? this._getTotal() : kickPoints;
      usageBalancePoint = isUseKickPoints ? pointUsage : 0;
      const priceAfterKickPointsUsage = this._getTotal() - usageBalancePoint;
      remainingPayment = priceAfterKickPointsUsage;
      usageBalanceSeller = 0;
      usageBalance = 0;
    } else if (!isUseKickPoints && isCreditUse) {
      // Kick point split payment calculation
      usageBalancePoint = 0;

      // Seller credit split payment calculation
      const sellerBalanceUsage = sellerCredit >= this._getTotal() ? this._getTotal() : sellerCredit;
      usageBalanceSeller = this._getTotal() > 0 ? sellerBalanceUsage : 0;
      const priceAfterSellerCreditUsage = this._getTotal() - usageBalanceSeller;

      // Kick credit split payment calculation
      const creditBalanceUsage = _balance >= priceAfterSellerCreditUsage ? priceAfterSellerCreditUsage : _balance;
      usageBalance = priceAfterSellerCreditUsage > 0 ? creditBalanceUsage : 0;
      remainingPayment = this._getTotal() - usageBalancePoint - usageBalanceSeller - usageBalance;
    } else {
      usageBalance = 0;
      usageBalancePoint = 0;
      usageBalanceSeller = 0;
      remainingPayment = this._getTotal();
    }

    return {
      remainingPayment,
      usageBalancePoint,
      usageBalanceSeller,
      usageBalance
    }
  }

  _handleBalanceUsage = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    const { remainingPayment, usageBalance, usageBalancePoint, usageBalanceSeller } = this._handleCalculation();

    this.setState({
      sellerCreditUsage: usageBalanceSeller,
      balanceUsage: usageBalance,
      kickPointsUsage: usageBalancePoint
    }, () => {
      this._handlePaymentType()
    })
  }

  _handleUmbreShippingCheckedChange(value) {
    if (!value) {
      this._onUmbreShippingValueChange(value);
      this._calculateShippingFee(this._getProvinceId());
    } else if (this.state._umbreEnabled)
      this._onUmbreShippingValueChange(value);
  }

  _onUmbreShippingValueChange = value => {
    const { _discount, _shippingFee, _paymentType } = this.state;
    const { ratio } = this.props;

    this.setState({
      umbreShipping: value,
      _shippingFee: value ? 0 : this.state._shippingFee,
      _productPromo: value ? 150000 : 0,
      _administrationFee: value
        ? this._getAdmFee(
            _paymentType,
            this.props.bidAmount / ratio,
            0,
            _discount
          )
        : this.state._administrationFee
    });
  };

  _toggleUmbreEnabled(provinceId, cityId) {
    const _umbreEnabled = validateUmbre(provinceId, cityId);
    if (_umbreEnabled !== this.state.umbreShipping && !_umbreEnabled) {
      const { weight } = this.props.product;
      this._onUmbreShippingValueChange(_umbreEnabled);
      this._calculateShippingFee(provinceId);
    }
    this.setState({ _umbreEnabled });
  }

  onChooseShipping(shipping_selected) {
    this._onUmbreShippingValueChange(false);
    if (shipping_selected === "NEW_SHIPPING") {
      this.setState({
        _alias: "",
        _fullName: "",
        _phone: "",
        _phoneSelected: "",
        _phoneNumber: "",
        _alamat: "",
        _notes: "",
        _province: "",
        _postalCode: "",
        _stillfetchCity: false,
        _countrySelected: null,
        _province: "",
        _provinceSelected: null,
        _city: "",
        _citySelected: null,
        _id_shipping: "",
        addingShipping: true,
        _umbreEnabled: false,
        _error: "",
        _phoneSelected: null
      });
    } else {
      const codeArea = this.state._phoneList.find(
        item => item.label == parsePhoneCode(shipping_selected.phone_number)
      );

      this.setState(
        {
          _alias: shipping_selected.alias || "",
          _fullName: shipping_selected.full_name,
          _phone: codeArea,
          _phoneNumber:
            shipping_selected.phone_number &&
            parsePhone(
              shipping_selected.phone_number,
              true,
              codeArea && codeArea.label
            ),
          _alamat: shipping_selected.street_address,
          _notes: shipping_selected.note,
          _countryCodeSelected: shipping_selected.country,
          _province: shipping_selected.province,
          _postalCode: shipping_selected.postal_code,
          _stillfetchCity: true,
          _city: shipping_selected.city,
          _id_shipping: shipping_selected.id,
          addingShipping: false,
          _error: "",
          _phoneSelected: codeArea
        },
        () => {
          this._buildCountryOptions();
          // this._calculateShippingFee(this._getProvinceId());
        }
      );
    }
  }

  _updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  _handleOnRetryCalculateShippingFee = e => {
    e.preventDefault();
    this._calculateShippingFee(this._getProvinceId());
  };

  _calculateShippingFee = async provinceId => {
    const { id, weight } = this.props.product;
    await this.setState({
      _isErrorShippingFetch: false
    });
    this.props.getShippingFee({
      destination: provinceId,
      weight: weight || 1000,
      product_variant_id: id,
      courier: "FLAT_RATE"
    });
  };

  _renderError = () => {
    const { _error } = this.state;
    if (_error !== null) {
      switch (_error.status_code) {
        case 422:
          return (
            <Alert color="danger">
              Please check{" "}
              {_error && _error.errorShipping
                ? "your address details"
                : "your payment details"}{" "}
              and try again.
            </Alert>
          );
        case 500:
          return (
            <Alert color="danger">
              {_error.hasMessageCustom
                ? _error.message
                : "Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425"}
            </Alert>
          );
        case 400:
          return (
            <Alert color="danger">
              {_error.message
                ? _error.message
                : "Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425"}
            </Alert>
          );
        default:
          break;
      }
    }
    return null;
  };

  render() {
    const limit =
      parseInt(this.props.dataAuth.userdata.balance) < OFFER_DEPOSIT;
    const { errorSameSize } = this.state;
    const { product } = this.props;
    const urlProduct = product.vintage? `${this.props.match.url}?vintage=true` : this.props.match.url;

    return (
      <div className="main-container">
        <ModalOutOfStock
          isOpen={this.state._openModalError}
          // isCloseable={true}
          message={errorSameSize == true ? ERROR_SAME_OFFER : OUT_OF_STOCK_MSG}
          buttonPrimaryText={"CHECK AVAILABLE SIZES"}
          onButtonPrimaryClick={() => {
            const {
              id,
              slug,
              selectedSize
            } = this.props.history.location.state;
            this.props.history.replace(urlProduct)
          }}
        />
        <Col
          xs={12}
          sm={12}
          md={12}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <SneakerInfoContainer
            {...this.props}
            display_note={false}
            onCancel={this.props.onCancel}
            offerPage={true}
            showPrice={false}
            history={this.props.history}
          />
          <InputOffer
            ref={input => (this.inputOfferRef = input)}
            dataAuth={this.props.dataAuth}
            _bidAmount={this.props.bidAmount}
            _handleBidAmount={this.props.handleBidAmount}
            _error={this.state._error}
            _messageField={this.state._messageField}
            handleSetBidAmount={this.props.handleSetBidAmount}
            handleTermsOffer={this.toggleModalTermsOffer}
          />
          <ModalTermsOffer
            isOpen={this.state._termsOffer}
            onToggle={this.toggleModalTermsOffer}
            preventKickCredit={this.state._bidValidation}
          />
          <NoteOffer />
          <UserBalanceInfoModal
            isOpenModalInfo={this.state.isOpenModalInfo}
            onToggle={this.onToggleBalanceInfo}
          />

          <BottomSection
            {...this.props}
            ref={ref => (this.shippingPaymentRefs = ref)}
            pageOffer
            dataPostalCode={this.props.dataPostalCode}
            //payment stuff
            _getTotal={this._getTotal}
            _handlePaymentTypeChange={this._handlePaymentTypeChange}
            _setPaymentType={value => this.setState({ _paymentType: value })}
            _paymentType={this.state._paymentType}
            _handleWalletPaymentCheckedChange={
              this._handleWalletPaymentCheckedChange
            }
            walletPayment={this.state.walletPayment}
            _shippingFee={this.state._shippingFee}
            _umbreEnabled={this.state._umbreEnabled}
            _handleUmbreShippingCheckedChange={
              this._handleUmbreShippingCheckedChange
            }
            umbreShipping={this.state.umbreShipping}
            offerAmount={this.props.bidAmount}
            _admFee={this._getAdmFee}
            _dataAuth={this.props.dataAuth}
            _getTotalWithoutWallet={this._getTotal}
            _getWalletValue={this._getWalletValue}
            _hasError={this._hasError}
            _productPromo={this.state._productPromo}
            _balanceUser={this.state._balance}
            sellerCredit={this.state.sellerCredit}
            kickPoints={this.state.kickPoints}
            sellerCreditUsage={this.state.sellerCreditUsage}
            balanceUsage={this.state.balanceUsage}
            isCreditUse={this.state.isCreditUse}
            isUseKickPoints={this.state.isUseKickPoints}
            kickPointsUsage={this.state.kickPointsUsage}
            //shipping stuff
            _id_shipping={this.state._id_shipping}
            _alias={this.state._alias}
            _fullName={this.state._fullName}
            _phoneNumber={this.state._phoneNumber}
            _alamat={this.state._alamat}
            _notes={this.state._notes}
            _postalCode={this.state._postalCode}
            _note={this.state._note}
            _phoneList={this.state._phoneList}
            _phone={this.state._phone}
            _phoneSelected={this.state._phoneSelected}
            _phoneCodeSelected={this.state._phoneCodeSelected}
            _countryList={this.state._countryList}
            _countrySelected={this.state._countrySelected}
            _countryCodeSelected={this.state._countryCodeSelected}
            _provinceList={this.state._provinceList}
            _province={this.state._province}
            _provinceSelected={this.state._provinceSelected}
            _cityList={this.state._cityList}
            _city={this.state._city}
            _citySelected={this.state._citySelected}
            _handleSelectPhoneChange={this._handleSelectPhoneChange}
            _handleSelectCountryChange={this._handleSelectCountryChange}
            _handleSelectProvinceChange={this._handleSelectProvinceChange}
            _handleSelectCityChange={this._handleSelectCityChange}
            onChooseShipping={this.onChooseShipping}
            _handleChange={this._handleChange}
            addingShipping={this.props.addingShipping}
            _renderError={this._renderError}
            _error={this.state._error}
            _updateState={this._updateState}
            //category
            category={this.props.dataCategory.selected}
            isErrorShippingFetch={this.state._isErrorShippingFetch}
            onRetryCalculateShippingFee={
              this._handleOnRetryCalculateShippingFee
            }
            _handleKickPointCheckedChange={this._handleKickPointCheckedChange}
            _handleBalanceUsage={this._handleBalanceUsage}
            onToggleBalanceInfo={this.onToggleBalanceInfo}
          />

          {/* <div>
            <p className="text-danger">{this.state._error!==null && this.state._error.status_code===422? this.state._error && this.state._error.message:undefined}</p>
          </div> */}
          {this.props.dataOffer.submitOffer.isSubmit ? (
            <Loading center />
          ) : this.props.bidAmount == 0 ? (
            <div className="disable-button" style={{ marginBottom: "15px" }}>
              <span>PLACE OFFER</span>
            </div>
          ) : (
            <Button
              onClick={this._submitOffer}
              className="btn-green"
              style={{ marginBottom: "15px" }}
              // className={classNames('btn-green', {'disabled': this.props.bidAmount == 0})}
            >
              PLACE OFFER
            </Button>
          )}
          <Link to={urlProduct} replace>
            <Button className="btn-white flat">BACK TO PRODUCT</Button>
          </Link>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dataCountries: state.dataPostalCode.countries,
    dataProvinces: state.dataPostalCode.provinces,
    dataCities: state.dataPostalCode.cities,
    dataOffer: state.dataOffer,
    dataCouriers: state.dataPostalCode.couriers,
    dataPostalCode: state.dataPostalCode,
    dataCategory: state.dataCategory,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    dataAuth: state.dataAuth,
    balance: state.dataAuth.userdata.balance
  };
};

const mapDispatchToProps = dispatch => ({
  doPostUserOffer: payload => dispatch(doPostUserOffer(payload)),
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: country => dispatch(doFetchProvinces(country)),
  getCities: (country = "", province = "") =>
    dispatch(doFetchCities(country, province)),
  getShippingFee: ({
    destination,
    origin = 153,
    weight = 1000,
    courier = "FLAT_RATE",
    product_variant_id
  }) =>
    dispatch(
      doPostShippingCost({
        destination,
        origin,
        weight,
        courier,
        product_variant_id
      })
    ),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  bidValidation: () => dispatch(doBidValidation()),
  doFetchProfile: () => dispatch(doFetchProfile())
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailOffer);

const ButtonBuy = styled.button`
  text-decoration: underline;
  color: #4990e2;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;
